<script>
  import axios from "axios"
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { onMount, onDestroy, afterUpdate } from "svelte"
  import { push } from "svelte-spa-router"
  import ApplicationState from "../../../../Stores/applicationStates"
  import templateStore, { templateToJSON, jsonToTemplate } from "../../../../Stores/metadataStore"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import Loader from "../../../../Shared/Slots/loader.svelte"
  // import Dropdown from "../../../../Shared/dropdown.svelte"
  import Tabs from "./components/tabs.svelte"
  import notify from "../../../../Script/notify"
  import Preview from "./metadata/preview.svelte"
  import FormEditor from "./metadata/formEditor.svelte"
  import {} from "../../../../Script/types"
  import JsonEditor from "./metadata/jsonEditor.svelte"
  import TemplatesList from "../../../../Stores/templatesList"
  import DeleteConfirmation from "../../Email/Shared/deleteConfirmation.svelte"
  import { removeEmptyKeys } from "../../../../Script/removeEmptyKey"
  import BackModal from "../Shared/backModal.svelte"
  import { compareObjects } from "../../../../Script/compareObjects"
  import DropDown from "../../../../Shared/dropDown2.svelte"
  import { getFileListPerPage, getEmailListPerPage, getFileTemplate, getEmailTemplate } from "../script/script"
  import { getEmailList } from "../../Email/Script/emailTemp"
  import { flatenObject } from "../../../../Script/flatenObject"
  import { generateHTMLContent } from "../../../../Script/generateHTMLContent"
  import Loading from "./components/loading.svelte"
  import { isValidJSONObject } from "./script/checkValidJson"
  import { checkJsonKeysLength } from "./script/checkJsonKeyLength"
  import { checkKeysValidity } from "./script/checkJsonKeysValidity"
  import { checkObjectSections } from "./script/checkObjectSection"
  import { checkDuplicateKeys } from "./script/checkJsonDuplicateKeys"
  import { formatJSONString } from "./script/makeJsonUnique"
  import { getRequest, postRequest } from "../../../../Script/apiMethods"
  // import {removeDuplicateKeys} from "../../../../Script/removeDuplicateKey"

  /**
   * @type {HTMLElement} - input element
   */
  let input

  /**
   * @type {Number} - to stop seTimeout function after a specified time in clearTimeout
   */
  let timer

  /**
   * @type {Number} - maximum character count for template name
   */
  let maxCharacters = 25

  /**
   * The template object.
   * @type {Object}
   */
  let template = {}

  /**
   * @typedef {Object} invalidNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {invalidNotification}
   */
  let invalidNotification = {
    close() {},
  }

  /**
   * @typedef {Object} emptyNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {emptyNotification}
   */
  let emptyNotification = {
    close() {},
  }

  /**
   * Flag indicating whether to show the loading state.
   * @type {Boolean}
   */
  let showLoading = true

  /**
   * @type {HTMLElement} - parent division for tabindex
   */
  let component

  /**
   * The loading text as message during document loading.
   * @type {String}
   */
  let loadingText = "Fetching&nbsp;<strong>Template Details</strong>&nbsp;"

  /**
   * @type {Boolean} for showing the Delete Document Template Confirmation Modal
   */
  let showDeleteModal = false

  /**
   * The name of the template.
   * If not provided, it defaults to "template-test".
   * @type {String}
   */
  template.name = template.name ? template.name : "template-test"

  /**
   * @typedef {Object} Notification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {Notification}
   */
  let notification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} keyNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {keyNotification}
   */
  let keyNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  let allowedCharsRegex = /^[A-Za-z-\s()+&0-9.]*$/
  /**
   * The query string parsed as JSON using spa-router.
   * @type {Object}
   */
  let query = {}

  /**
   * @type {String} - to specify document type in delete confirmation Modal
   */
  let templateType = "Document"

  /**
   * @typedef {Object} emptyKeyNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {emptyKeyNotification}
   */
  let emptyKeyNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} getDocNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {getDocNotification}
   */
  let getDocNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} saveNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {saveNotification}
   */
  let saveNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} deleteNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {deleteNotification}
   */
  let deleteNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} filePreviewNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {filePreviewNotification}
   */
  let filePreviewNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} recNameNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {recNameNotification}
   */
  let recNameNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} invalidJSONNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {invalidJSONNotification}
   */
  let invalidJSONNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} manKeysNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {manKeysNotification}
   */
  let manKeysNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} duplicateKeysNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {duplicateKeysNotification}
   */
  let duplicateKeysNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} createDocNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {createDocNotification}
   */
  let createDocNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} emailPreviewNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {emailPreviewNotification}
   */
  let emailPreviewNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} parentKeysNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {parentKeysNotification}
   */
  let parentKeysNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @type {number} pageNumber
   */
  let filepage = 1
  /**
   * @type {number} pageNumber
   */
  let emailpage = 1
  /**
   * @type {number} total file count
   */
  let count
  /**
   * @type {number} total pages
   */
  let maxPage
  /**
   * @type {number} starting count of the fileList
   */
  let startCount = 1
  /**
   * @type {number} ending count of the fileList
   */
  let endCount = 10
  /**
   * @type {number} total email count
   */
  let emailCount
  /**
   * @type {number} total pages
   */
  let emailmaxPage
  /**
   * @type {number} starting count of the emailList
   */
  let emailStartCount = 1
  /**
   * @type {number} ending count of the emailList
   */
  let emailEndCount = 10
  /**
   * @type {boolean} whether to show loading screen or not for dropdown
   */
  let showLoadingForDropDown = false

  // /**
  //  * @type {Boolean} - to check json content have duplicate keys.
  //  */
  // let hasDuplicateKeys = false

  /**@type {String} - File template name in dropdown*/
  let fileTempName

  /**@type {String} - Email template name in dropdown*/
  let emailTempName

  /**
   * @type {Array<tabItem>} items - list of tab items
   */
  let items = [
    {
      id: "Metadata",
      iconClass: "fa-solid fa-pen-field",
      component: FormEditor,
    },
    {
      id: "Preview",
      iconClass: "fa-solid fa-eye",
      component: Preview,
    },
    {
      id: "JSON",
      iconClass: "fa-solid fa-brackets-curly",
      component: JsonEditor,
    },
  ]

  /**
   * @type {Boolean}- to open modal when press back
   */
  let showBackmodal = false

  let loadDropdown = false

  /**
   * @type {Number} - json key max length
   */
  let maxKeyLength = 30

  /**
   * @type {Number} - json key max length
   */
  let maxValueLength = 120

  /**
   * Indicates whether the file modal is open or not.
   * @type {Boolean}
   */
  let isFileModalOpen = false

  /**
   * Indicates whether the email modal is open or not.
   * @type {Boolean}
   */
  let isEmailModalOpen = false

  /**
   * The source of the file template.
   * @type {String}
   */
  let fileSrc

  /**
   * @type {HTMLElement} - email and file preview container element to modify height based on screen innerheight
   */
  let emailPreviewHeight

  /**
   * @type {String} - Email Content from Api call to use in to identify flat object values
   */
  let parsedEmailContent

  /**
   * @type {HTMLElement} the html element for the email content
   */
  let htmlContent
  /**
   * @type {Object} - response from email API call to fetch details to parsed content function
   */
  let emailData

  /**
   * @type {Object} - flatened objects to apply in parse content function to display metadata from document selected
   */
  let flatObject

  /**@type{Boolean} - to disable preview button untill the preview loading*/
  let previewLoading = false

  let unsubscribe
  /**@type{String} - qrcode to be shown in email template preview*/
  let qrSource = ""

  /**
   * @description - function to check not to exceed max characters
   */
  const checkMaxCharacters = () => {
    //Deleting existing notification
    notification.close()
    if (template.name.length >= maxCharacters) {
      //setting timer to display max character before deleting.
      setTimeout(() => {
        //returning values only in range below max characters
        template.name = template.name.slice(0, maxCharacters)
      }, 20)
      //Displaying notification for exceeding maximum characters character
      notification = notify.info(`Template name should not be more than ${maxCharacters} characters`)
    }
  }

  /**
   * function to check for given pattern to template name
   * @param e - to capture key event
   */
  const checkSpecialChars = async (e) => {
    if (input) {
      const info = "PAGE: Edit Document template\nEVENT: Validating invalid characters for the document template name during onBlur/ onPaste/ onKeypress"

      try {
        // Destructure the type and key properties from the event object
        let { type, key } = e

        // Check if it's a keypress event and the pressed key is not allowed using regex pattern
        if (type === "keypress" && !allowedCharsRegex.test(key)) {
          // Prevent the default keypress behavior if the pressed key is not allowed
          e.preventDefault()
          //appending typed invalid characters before deleting
          template.name += key

          invalidNotification.close()
          // Show a danger notification indicating the allowed characters
          invalidNotification = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
          //setting timer to display deleting invalid character
          setTimeout(() => {
            template.name = template.name.slice(0, -1)
          }, 100)
        } else if (type === "paste" || type === "blur") {
          // // Prevent the default paste behavior
          // e.preventDefault()
          // The plain text content retrieved from the clipboard
          let pastedText

          if (type === "blur") {
            pastedText = template.name
          } else {
            // Get the pasted text from the clipboard
            let clipboardData = e.clipboardData || window.clipboardData
            pastedText = clipboardData.getData("text/plain")
          }

          setTimeout(() => {
            invalidNotification.close()
            // Check if the pasted text contains any invalid special characters
            if (!allowedCharsRegex.test(pastedText)) {
              // Remove any characters that are not allowed
              let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()

              // Check if the sanitized text is the same as the original pasted text
              if (sanitizedText !== pastedText) {
                invalidNotification = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&. are allowed.", info)
              }

              // Set the input value to the sanitized text
              template.name = sanitizedText
            }
            //calling check maximum characters function
            checkMaxCharacters()
          }, 500)
        }
      } catch (error) {
        notify.danger(error, info)
      }
    }
  }

  /**
   * @type {Object} - Template data deep copy saved on onMount to compare with modified data to show back modal
   */
  let oldDocumentData = {}

  /**
   * @description Fetches a document template by ID.
   * @returns {Promise<void>}
   */
  const getDocumentTemplate = async () => {
    try {
      //check if template name is empty
      if (!template.name) throw "Kindly enter a name for a template"

      // Fetching document template by ID
      const { template: docTemplate } = await getRequest(`/api/swagger/v2/templates/documents/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      return docTemplate
    } catch (error) {
      throw "Error fetching Document Template Details"
    }
  }

  const createNewDocTemplate = async () => {
    try {
      let dummyTemplate = {
        name: "",
        file: "",
        email: "",
        metadata: '{"receiver":{"name":""},"document":{"type":""},"issuer":{"signatory":""}}',
      }

      //api call to create new document template
      const { template } = await postRequest("/api/swagger/v2/templates/documents", dummyTemplate, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      return template
    } catch (error) {
      throw "Error Creating Document Template"
    }
  }

  /**
   * @description Fetches the list of file templates.
   * @returns {Promise<void>}
   */
  const getFileList = async () => {
    try {
      // Retrieve the list of documents
      let fileList = await getFileListPerPage(filepage)

      count = fileList.count

      maxPage = Math.ceil(count / 10)

      $TemplatesList.file = fileList.templates

      if (template.file) {
        try {
          let fileData = await getFileTemplate(template.file)
          fileTempName = fileData.name
        } catch (error) {
          fileTempName = "Choose a File Design Template"
        }
      } else {
        fileTempName = "Choose a File Design Template"
      }

      endCount = maxPage == 1 ? count : endCount
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Pushes a new state to the browser history and handles the onpopstate event.
   * @returns {Promise<void>}
   */
  const historyPushState = async () => {
    try {
      // Push a new state to the history whenever a new browserpage is loaded
      window.history.pushState(null, null, window.location.href)

      // Handle the onpopstate event when the user navigates back or forward in history
      window.onpopstate = function (event) {
        let stopSave = false // Flag variable to indicate if saving should be stopped

        // Subscribe to the templateStore and execute the callback when changes occur
        unsubscribe = templateStore.subscribe((items) => {
          // Filter the items to find those with an empty "key" property
          let filterEmptyKey = items.filter((item) => item.key == "")

          if (filterEmptyKey.length) {
            // If there are items with an empty "key" property, set stopSave to true
            stopSave = true
          }
        })

        if (stopSave) {
          // Close the previous notification, if any
          emptyKeyNotification.close()
          const info = "PAGE: Edit Document template\nEVENT: While leaving page without providing template name"
          // Show a danger notification indicating that a value for "key" is required
          emptyKeyNotification = notify.danger("Kindly enter a value for key", info)
          // Exit the function, preventing further execution
          return
        }

        //check if no template name value
        // if (!template.name) {
        //   // Close the previous notification, if any
        //   notification.close()
        //   // Show a danger notification indicating that a name for the template is required
        //   notification = notify.danger("Kindly enter a name for a template")
        // }
        // Check if the document template has unsaved changes
        if (compareObjects(oldDocumentData, JSON.parse(JSON.stringify(template))) === false) {
          // Push another state to prevent navigating back
          window.history.pushState(null, null, window.location.href)

          if (!showBackmodal) {
            showBackmodal = true // Show the back modal to confirm navigation
          }
        }
      }
    } catch (error) {
      // console.error(error) // Log the error to the console
    }
  }

  const extractMetadata = async (inputObject) => {
    return {
      receiver: { ...inputObject.receiver },
      document: { ...inputObject.document },
      issuer: { ...inputObject.issuer },
    }
  }

  // /**
  //  * Recursively removes duplicate keys from an object within the same object, considering keys to be case-insensitive.
  //  *
  //  * @param {Object} obj - The object to process.
  //  * @returns {Object} - A new object with duplicate keys removed within the same object, preserving the original case.
  //  */
  // const removeDuplicateKeys = (obj) => {
  //   // Check if the input is not an object or is null, return it as is
  //   if (typeof obj !== "object" || obj === null) {
  //     return obj
  //   }

  //   // If the input is an array, recursively process each item in the array
  //   if (Array.isArray(obj)) {
  //     return obj.map((item) => removeDuplicateKeys(item))
  //   }

  //   // Create an empty object to store the result without duplicate keys
  //   const result = {}
  //   // Create a Set to keep track of seen keys
  //   const seenKeys = new Set()

  //   // Iterate through the keys of the input object
  //   for (const key in obj) {
  //     // Check if the key is a direct property of the object
  //     if (Object.prototype.hasOwnProperty.call(obj, key)) {
  //       // Normalize the key by converting it to lowercase
  //       const normalizedKey = key.toLowerCase()

  //       // Check if the normalized key has not been seen before
  //       if (!seenKeys.has(normalizedKey)) {
  //         // Add the normalized key to the set of seen keys
  //         seenKeys.add(normalizedKey)
  //         // Recursively process the value associated with the key and add it to the result
  //         result[key] = removeDuplicateKeys(obj[key])
  //       } else {
  //         // Set a variable indicating duplicate keys are found
  //         hasDuplicateKeys = true
  //       }
  //     }
  //   }
  //   // Return the object with duplicate keys removed
  //   return result
  // }

  /**
   * loading editing templte details by updating its data to stores
   */
  onMount(async () => {
    try {
      query = queryStringToJSON($querystring)

      if (!query.id) throw "Template ID Not Found"

      //display top of the page while onMount
      document.body.scrollIntoView()

      // Attach the keydown event listener to the window when the component mounts
      window.addEventListener("keydown", handleKeydown)

      try {
        showLoading = true
        if (query.id == "000000000000000000000000") {
          template = await createNewDocTemplate()
          query.id = template.id
        } else {
          template = await getDocumentTemplate()
        }

        // Make a deep copy of the template and assign it to `oldDocumentData`
        oldDocumentData = JSON.parse(JSON.stringify(template))

        let metadataValue = JSON.parse(template.metadata)
        removeEmptyKeys(metadataValue)

        // Convert the metadata value to a template format
        let templatedata = jsonToTemplate(metadataValue)

        // Update the template store with the converted template data
        templateStore.update(() => {
          return templatedata
        })

        let redirectionQuery = `?id=${template.id}`

        if (query.documentID) redirectionQuery = `?id=${template.id}&documentID=${query.documentID}`
        if (query.badgeId) redirectionQuery = `?id=${template.id}&documentID=${query.documentID}&badgeId=${query.badgeId}`

        push(`/templates/document/edit${redirectionQuery}`)
      } catch (error) {
        throw error
      } finally {
        showLoading = false
      }

      template.metadata = await extractMetadata(template.metadata)
      try {
        loadDropdown = true
        // Retrieve the list of email
        let emailList = await getEmailList(emailpage)

        $TemplatesList.email = emailList.templates

        emailCount = emailList.count
        emailmaxPage = Math.ceil(emailCount / 10)

        emailEndCount = emailmaxPage == 1 ? emailCount : emailEndCount

        if (template.email) {
          try {
            let emailData = await getEmailTemplate(template.email)

            emailTempName = emailData.name
          } catch (error) {
            emailTempName = "Choose a Email Template"
          }
        } else {
          emailTempName = "Choose a Email Template"
        }
      } catch (error) {
        const info = "PAGE: Edit Document template\nEVENT: Error fetching email template list during onMount"
        notify.danger(error, info)
        // push("/templates/document")
      }
      try {
        loadDropdown = true
        await getFileList()
      } catch (error) {
        const info = "PAGE: Edit Document template\nEVENT: Error fetching file template list during onMount"
        notify.danger(error, info)
      }
      await historyPushState()
    } catch (error) {
      const info = "PAGE: Edit Document template\nEVENT: onMount"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      loadDropdown = false
    }
  })

  /**
   * @description function to save edited template
   */
  const save = async () => {
    try {
      saveNotification.close()
      // Close the notifications
      emptyKeyNotification.close()
      recNameNotification.close()
      invalidJSONNotification.close()
      manKeysNotification.close()
      duplicateKeysNotification.close()
      parentKeysNotification.close()
      // Set showBackmodal to false to hide the back modal
      showBackmodal = false
      // Trim any leading or trailing spaces from the template name
      // If the template name is empty, exit the function

      // check if no template name value
      if (!template.name) throw "Kindly enter a name for a template"

      trimSpacesTemplateName()
      // Initialize a flag variable to indicate if saving should be stopped
      let stopSave = false
      // Subscribe to the templateStore and execute the callback when changes occur

      unsubscribe = templateStore.subscribe((items) => {
        // Filter the items to find those with an empty "key" property
        let filterEmptyKey = items.filter((item) => item.key == "")

        if (filterEmptyKey.length) {
          // If there are items with an empty "key" property, set stopSave to true
          stopSave = true
        }
      })

      if (stopSave) throw "Kindly enter a value for key"

      if ($ApplicationState.updateTempStoreJSON == true) {
        let parsedJson = $ApplicationState.jsonEditorContent

        if (isValidJSONObject(parsedJson) == false) {
          invalidJSONNotification = notify.warning("The JSON appears to be invalid. Please correct it to make as a valid JSON.")
          return
        }
        let testJson = JSON.parse($ApplicationState.jsonEditorContent)
        try {
          if (testJson.receiver == undefined || testJson.issuer == undefined || testJson.document == undefined) {
            throw null
          }
        } catch (error) {
          parentKeysNotification = notify.warning("Ensure that the <strong>receiver, document, issuer </strong> are not modified.")
          return
        }
        try {
          //targetting mandatory keys
          if (testJson.receiver.name == undefined || testJson.issuer.signatory == undefined || testJson.document.type == undefined) {
            throw null
          }
        } catch (error) {
          // console.error(error)
          manKeysNotification = notify.warning("Ensure mandatory Keys <strong>name, type, signatory </strong> are not modified.")
          return
        }
        let checkJson = $ApplicationState.jsonEditorContent
        formatJSONString(checkJson)
        try {
          checkDuplicateKeys($ApplicationState.jsonEditorContent)
        } catch (error) {
          duplicateKeysNotification = notify.warning(error)
          return
        }

        if (testJson.receiver.name) {
          recNameNotification = notify.warning("Receiver name should be empty, kindly remove the given value.")
          return
        }
        // try {
        //   testJson = removeDuplicateKeys(testJson)
        //   if (hasDuplicateKeys) {
        //     // Do something with the information that duplicate keys were found
        //     duplicateKeysNotification = notify.warning("Duplicate keys were found in the json, Kindly remove or modify them.")
        //     return
        //   }
        // } catch (error) {
        //   throw error
        // }

        try {
          await checkJsonKeysLength(testJson, maxKeyLength, maxValueLength)
        } catch (error) {
          saveNotification = notify.warning(error.toString())
          return
        }
        try {
          await checkKeysValidity(testJson)
        } catch (error) {
          saveNotification = notify.warning(error.toString())
          return
        }
        if ((await checkObjectSections(testJson)) == false) {
          saveNotification = notify.warning("JSON should contain <Strong> receiver, document, issuer </strong> properties only.")
          return
        }
        // Convert the `testJson` object to template data using the `jsonToTemplate` function and assign it to the `newTemplateData` variable.
        let newTemplateData = jsonToTemplate(testJson)

        // Update the `templateStore` by invoking the `update` function and returning the `newTemplateData`.
        templateStore.update(() => {
          return newTemplateData
        })
      }
      //updating metadata JSON String from template stores
      template.metadata = JSON.stringify(templateToJSON($templateStore))
      //displaying loading text indicating process going on
      loadingText = "Saving&nbsp;<strong>Document Template</strong>&nbsp;"
      //making showLoading true to display loading text
      showLoading = true

      /**
       * @description updating template details with changes made using patch method
       */
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

        const { data } = await axios.patch(`/api/swagger/v2/templates/documents/${query.id}`, template, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        //api error checking
        if (data.error && !data.success) {
          //throw if any error occurs during api call
          throw data.errorCode
        }

        /**
         * updating modified template details to existing details by matching its id in stores
         */
        TemplatesList.update((templates) => {
          //finding particular template in templatestore
          templates.document.find((docTemplate) => {
            // matching document template id with query id from api call
            if (docTemplate.id == query.id) {
              //assigning updating template to document template based on id equal to founded id
              docTemplate = template
            }
          })
          return templates
        })
        //empty the metadata stores to avoid issue while opening carousel which caused issue fetched with existing data
        $templateStore = []
        //closing loading message
        showLoading = false
        //throw success notification on successful saving of document
        notify.success(`Document template <strong style="hyphens: auto;">${template.name}</strong> <strong>saved</strong> successfully`)
        //rediret to templates list
        if (query.badgeId) push(`/publish/badge/doctemplate?documentId=${query.documentID}&badgeId=${query.badgeId}`)
        else if (query.documentID) push(`/publish/single?documentId=${query.documentID}`)
        else push("/templates/document")
      } catch (error) {
        //closing loading message
        showLoading = false
        // console.error(error)
        //throws error as danger notification
        throw error
      }
    } catch (error) {
      // console.error(error)
      //throws error as danger notification
      const info = "PAGE: Edit Document template\nEVENT: While updating document template"
      saveNotification = notify.danger(error.toString(), info)
    }
    // finally {
    //   hasDuplicateKeys = false
    // }
  }

  /**
   * function to permanantly delete template from database and stores
   */
  const deleteTemplate = async () => {
    deleteNotification.close()
    showDeleteModal = false
    // if ($TemplatesList.disabled) $TemplatesList.disabled = false

    //displaying loading text indicating process going on
    loadingText = "Deleting&nbsp;<strong>Document Template</strong>&nbsp;"
    //making showLoading true to display loading text
    showLoading = true
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      const { data } = await axios.delete(`/api/swagger/v2/templates/documents/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      //api error checking
      if (data.error && !data.success) {
        throw data.errorCode
      }
      // updating stores after deleting template
      TemplatesList.update((templates) => {
        // Remove the deleted template from the document templates list
        templates.document = templates.document.filter((templateItem) => templateItem.id != query.id)
        return templates
      })

      // Show a success notification for the deletion
      notify.success(`Document Template <strong style="hyphens: auto;">${template.name}</strong> successfully <strong>deleted</strong>`)
      //push link to document templates list
      push("/templates/document")
    } catch (error) {
      //prints error in the console if any error occurs in try block
      // console.error(error)
      //throws error as danger notification
      const info = "PAGE: Edit Document template\nEVENT: While deleting document template"
      deleteNotification = notify.danger(error, info)
    } finally {
      showLoading = false //disabling loading message
    }
  }

  /**
   * @function - to handle keydown events on the window for tab index
   * @param event - targetting and checking tab index focusing nodes
   */
  const handleKeydown = (e) => {
    // Check if the Tab key is pressed and the focus is outside the component
    if (e.key === "Tab" && !component.contains(e.target)) {
      // Prevent default behavior
      e.preventDefault()
      // Move focus back to the component
      component.focus()
    }
  }

  /**
   * @description - function to remove trailing and leading spaces
   */
  const trimSpacesTemplateName = () => {
    // Remove leading and trailing spaces from the template name
    template.name = template.name.trim()
  }

  /**
   * Handles the cleanup tasks when the component is destroyed.
   */
  onDestroy(async () => {
    // Close the keyNotification, while leaving page
    if (keyNotification) keyNotification.close()
    // if ($TemplatesList.disabled) $TemplatesList.disabled = false

    // Remove the keydown event listener from the window when the component is destroyed
    window.removeEventListener("keydown", handleKeydown)
    //unsubscribe function for stores subscribe
    // unsubscribe()
  })

  /**
   * @description - Updates the metadata of the template after an update.
   * Converts the template data to a JSON string and assigns it to the `template.metadata` property.
   */
  afterUpdate(() => {
    // Convert template data to JSON and assign it to template.metadata
    template.metadata = JSON.stringify(templateToJSON($templateStore))
  })

  /**
   * @description - to go back to list page by checking any modifications done in template
   */
  const backToList = () => {
    // Close the keyNotification (if any)
    emptyKeyNotification.close()
    //to disable save process if any empty key exists in metadata
    let stopSave = false

    // Subscribe to the templateStore and execute the callback when changes occur
    unsubscribe = templateStore.subscribe((items) => {
      // Filter the items to find those with an empty "key" property
      let filterEmptyKey = items.filter((item) => item.key == "")

      if (filterEmptyKey.length) {
        // If there are items with an empty "key" property, set stopSave to true
        stopSave = true
      }
    })

    if (stopSave) {
      // Close the previous notification, if any
      emptyKeyNotification.close()
      const info = "PAGE: Edit Document template\nEVENT: While leaving document template to document list"
      // Show a danger notification indicating that a value for "key" is required
      emptyKeyNotification = notify.danger("Kindly enter a value for key", info)
      // Exit the function, preventing further execution
      return
    }
    if (compareObjects(oldDocumentData, JSON.parse(JSON.stringify(template))) === false) {
      //if any modifications done in template displaying back modal
      showBackmodal = true
      //stop the function execution
      return
    }

    //finally pushing to document templates list page
    push("/templates/document")
  }

  /**
   * Fetches the final set of file templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFileFinalList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true
      // Store the file name from the event detail
      fileTempName = e.detail

      // Increment the filepage count to retrieve the next set of templates
      filepage = maxPage

      // Fetch the list of file templates for the updated filepage
      let fileList = await getFileListPerPage(filepage)

      // Calculate the updated start and end counts for template display
      startCount = (maxPage - 1) * 10 + 1

      endCount = count

      // Update the TemplatesList with the fetched email templates
      $TemplatesList.file = fileList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of file template on 'Move Last' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }
  /**
   * Fetches the final set of email templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchEmailFinalList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true
      // Store the email template name from the event detail
      emailTempName = e.detail

      // Increment the emailpage count to retrieve the next set of templates
      emailpage = emailmaxPage

      // Fetch the list of email templates for the updated emailpage
      let emailList = await getEmailListPerPage(emailpage)

      // Calculate the updated start and end counts for template display
      emailStartCount = (emailmaxPage - 1) * 10 + 1

      emailEndCount = emailCount

      // Update the TemplatesList with the fetched email templates
      $TemplatesList.email = emailList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of email template on 'Move Last' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the initial set of file templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchEmailInitialList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      emailTempName = e.detail

      // Increment the emailpage count to retrieve the next set of templates
      emailpage = 1

      // Fetch the list of file templates for the updated emailpage
      let emailList = await getEmailListPerPage(emailpage)

      // Calculate the updated start and end counts for template display
      emailStartCount = 1
      emailEndCount = 10

      // Update the TemplatesList with the fetched file templates
      $TemplatesList.email = emailList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of email template on 'Move Forward' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }
  /**
   * Fetches the initial set of file templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFileInitialList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true
      // Store the document name from the event detail
      fileTempName = e.detail

      // Increment the filepage count to retrieve the next set of templates
      filepage = 1

      // Fetch the list of file templates for the updated filepage
      let fileList = await getFileListPerPage(filepage)

      // Calculate the updated start and end counts for template display
      startCount = 1
      endCount = 10

      // Update the TemplatesList with the fetched file templates
      $TemplatesList.file = fileList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of file template on 'Move Forward' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  // This function is called when a file's content changes
  const onFileTempChange = async (e) => {
    try {
      // Update the emailTemplate object with the new file content
      template.file = e.detail

      if (template.file) {
        // If there is file content, fetch additional information about the document
        let fileData = await getFileTemplate(template.file)
        fileTempName = fileData.name
      }
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While changing file template"
      notify.danger(error, info)
    }
  }

  // This function is called when a email's content changes
  const onEmailTempChange = async (e) => {
    try {
      // Update the emailTemplate object with the new file content
      template.email = e.detail

      if (template.email) {
        // If there is document content, fetch additional information about the document
        let emailData = await getEmailTemplate(template.email)
        emailTempName = emailData.name
      }
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While changing email template"
      notify.danger(error, info)
    }
  }

  /**
   * Function for changing the file Template Name
   * @param {CustomEvent} e dispatched value from the component
   */
  const changeFileName = async (e) => {
    // assigning the file template name shown in tha dropdown
    fileTempName = e.detail
  }
  /**
   * Function for changing the email Template Name
   * @param {CustomEvent} e dispatched value from the component
   */
  const changeEmailName = async (e) => {
    // if (template.email) {
    // assigning the email template name shown in tha dropdown
    emailTempName = e.detail
    // }
  }

  /**
   * Fetches the next set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFileNextTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      fileTempName = e.detail

      // Increment the filepage count to retrieve the next set of templates
      filepage++

      // Fetch the list of document templates for the updated filepage
      let fileList = await getFileListPerPage(filepage)

      // Calculate the updated start and end counts for template display
      if (filepage === 1) {
        startCount = filepage + 10
        if (maxPage === filepage) endCount = count
        else endCount = 10
      } else {
        startCount = startCount + 10
        if (maxPage === filepage) endCount = count
        else endCount = startCount + 9
      }

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.file = fileList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of file template on 'Next' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }
  /**
   * Fetches the next set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchEmailNextTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      emailTempName = e.detail

      // Increment the emailpage count to retrieve the next set of templates
      emailpage++

      // Fetch the list of document templates for the updated emailpage
      let emailList = await getEmailListPerPage(emailpage)

      // Calculate the updated start and end counts for template display
      if (emailpage === 1) {
        emailStartCount = emailpage + 10
        if (emailmaxPage === emailpage) emailEndCount = emailCount
        else emailEndCount = 10
      } else {
        emailStartCount = emailStartCount + 10
        if (emailmaxPage === emailpage) emailEndCount = emailCount
        else emailEndCount = emailStartCount + 9
      }

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.email = emailList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of email template on 'Next' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the previous set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFilePreviousTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true
      // if (template.file) {
      // Store the document name from the event detail
      fileTempName = e.detail

      // Decrement the filepage count to retrieve the previous set of templates
      filepage--

      // Fetch the list of document templates for the updated filepage
      let fileList = await getFileListPerPage(filepage)

      // Calculate the updated start and end counts for template display
      startCount = startCount - 10
      endCount = startCount + 9

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.file = fileList.templates
      return
      // }
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of file template on 'Previous' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }
  /**
   * Fetches the previous set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchEmailPreviousTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      emailTempName = e.detail

      // Decrement the emailpage count to retrieve the previous set of templates
      emailpage--

      // Fetch the list of document templates for the updated emailpage
      let emailList = await getEmailListPerPage(emailpage)

      // Calculate the updated start and end counts for template display
      emailStartCount = emailStartCount - 10
      emailEndCount = emailStartCount + 9

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.email = emailList.templates
    } catch (error) {
      const info = "PAGE: Edit document template\nEVENT: While fetching the list of email template on 'Previous' button click"
      notify.danger(error, info)
      push("/templates/document")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  const filePreview = async () => {
    if (template.file) {
      filePreviewNotification.close()
      previewLoading = true
      //fetch file template details
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get(`/api/swagger/v2/templates/files/${template.file}`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })

        //assign data to variable for the purpose of fetching flatObject details
        // fileData = data
        if (data.template) {
          //assigning file name from api details
          // fileName = data.template.name
          //assigning file source from api details to display preview
          fileSrc = data.template.baseUri
        }

        //throw error if any error occurs during api call
        if (data.error && !data.success) {
          throw data.errorCode
        }
        openModal("file")
      } catch (error) {
        const info = "PAGE: Edit document template\nEVENT: While fetching file template details for preview"

        // console.error(error)
        // assigning error message for file template does not exist
        if (error == "P2BCODE::TEMPLATE_DOES_NOT_EXIST") {
          notify.danger("Selected File Design Template does not exist", info)
          return
        }

        //throws error as danger notification
        filePreviewNotification = notify.danger(error, info)
      } finally {
        previewLoading = false
      }
    }
  }

  /**
   * @description - Function that parses the content of the email template and generates the HTML content.
   */
  const parseContent = async () => {
    // Check if the DocumentCarousel has an email template
    if (template.email) {
      try {
        // Assign the parsedEmailContent to the parsedContent variable
        let parsedContent = parsedEmailContent

        // Get unique editor values from the parsed content using regular expressions
        let editorValues = Array.from(new Set(parsedContent.match(/(?<=\{\{).*?(?=\}\})/g)))

        // Check if there are editor values and the flatObject has properties
        if (editorValues.length && Object.keys(flatObject).length) {
          for (let i = 0; i < editorValues.length; i++) {
            // Replace editor values with corresponding values from the flatObject
            if (flatObject[editorValues[i]]) {
              parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, flatObject[editorValues[i]])
            }
            // Handle specific editor values with custom replacements
            else if (editorValues[i] == "url") {
              parsedContent = parsedContent.replaceAll(`{{url}}`, `<a href="https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;"><strong>https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592</strong></a>`)
            } else if (editorValues[i] == "qr") {
              let DEFAULT_URL = "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592"

              qrSource = `https://utils.print2block.in/qr/create/?size=120&data=${DEFAULT_URL}`
              parsedContent = parsedContent.replaceAll(`{{qr}}`, qrSource)
            } else if (editorValues[i] == "receiver_name") {
              parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "John Doe")
            } else if (editorValues[i] == "document_type") {
              parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "Certificate")
            } else if (editorValues[i] == "issuer_signatory") {
              parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "Controller")
            } else {
              parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, `<strong>${editorValues[i]}</strong>`)
            }
          }
        }

        /**
         * Generates the HTML content using the provided email template and parsed content.
         * @type {string}
         */
        htmlContent = generateHTMLContent(emailData.template, parsedContent)
      } catch (error) {
        throw error
      }
    }
  }

  const emailPreview = async () => {
    const info = "PAGE: Edit document template\nEVENT: While fetching email template details for preview"

    if (template.email) {
      emailPreviewNotification.close()
      previewLoading = true
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        //api call to fetch email template details
        const { data } = await axios.get(`/api/swagger/v2/templates/emails/${template.email}`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        //throw error if any error occurs during api call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        //assign data to variable for the purpose of fetching flatObject details
        emailData = data
        if (data.template) {
          //assign parsed data for metadata to display parsed content
          parsedEmailContent = data.template.content
        }

        openModal("email")
      } catch (error) {
        // console.error(error)
        //assigning error message for email template does not exist
        if (error == "P2BCODE::TEMPLATE_DOES_NOT_EXIST") {
          notify.danger(`Selected Email Template does not exist`, info)
          return
        }

        //throws error as danger notification
        emailPreviewNotification = notify.danger(error, info)
      } finally {
        previewLoading = false
      }
    }

    try {
      if (emailData) {
        let parsedJson = template.metadata

        // Flatten the nested object using the flatenObject function parsedJson as parameter
        flatObject = flatenObject(parsedJson)
      }
      // Call the parseContent function to parse the email template content and generate the HTML content
      await parseContent()
    } catch (error) {
      notify.danger(error, info)
    }
  }

  /**
   * Opens the specified modal type.
   * Updates the modal state based on the availability of file and email sources.
   * @param {string} modalType - The type of modal to open ("file" or "email")
   */
  const openModal = (modalType) => {
    setTimeout(async () => {
      try {
        /**
         * Determines if the file modal should be opened.
         * The file modal is opened if the modal type is 'file' and either the fileName or fileSrc is provided.
         * @type {boolean}
         */
        isFileModalOpen = modalType === "file" && fileSrc

        /**
         * Determines if the email modal should be opened.
         * The email modal is opened if the modal type is 'email' and either the emailName or emailSrc is provided.
         * @type {boolean}
         */
        isEmailModalOpen = modalType === "email"
      } catch (error) {
        const info = "PAGE: Edit document template\nEVENT: While displaying preview for email/ file template"
        notify.danger(error, info)
      }
    }, 100)
  }
</script>

<svelte:head>
  <title>Document Templates</title>
</svelte:head>

{#if showBackmodal}
  <BackModal
    on:cancel={() => {
      showBackmodal = false
    }}
    on:dontSave={() => {
      showBackmodal = false
      push("/templates/document")
    }}
    {templateType}
    on:click={async () => {
      await save()
      showBackmodal = false
    }}
  />
{/if}

{#if showDeleteModal}
  <DeleteConfirmation
    on:click={() => {
      showDeleteModal = false
    }}
    {template}
    DocumentType={templateType}
    on:delete={async () => {
      await deleteTemplate()
      showBackmodal = false
    }}
  />
{/if}

{#if isFileModalOpen || isEmailModalOpen}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="{isEmailModalOpen ? 'sticky' : 'fixed'} inset-0 z-30 flex {isEmailModalOpen ? (window.innerHeight >= emailPreviewHeight ? 'h-screen pt-24 mobile:pt-10' : 'h-max pt-24 mobile:pt-10') : 'h-full'} w-full cursor-pointer flex-col items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-800 backdrop-blur-md"
    on:click|preventDefault|stopPropagation={() => {
      isFileModalOpen = false
      isEmailModalOpen = false
    }}
  >
    {#if isFileModalOpen}
      <div class="flex items-center justify-center overflow-hidden">
        <div class="relative">
          <img on:click|stopPropagation src={fileSrc} class="relative flex max-h-[80vh] min-w-[300px] max-w-[350px] cursor-default items-center justify-center rounded-md mobile:p-0 sm:max-w-[700px]" alt="" />
        </div>
      </div>
      <div class="mb-6 mt-3 flex items-center justify-center text-lg font-semibold text-white mobile:text-xl">To close preview, click within the gray area.</div>
    {/if}
    {#if isEmailModalOpen}
      <div bind:clientHeight={emailPreviewHeight} on:click|stopPropagation class="isList cursor-default p-3 mobile:p-6 md:w-[1024px] md:p-12 lg:p-6 xls:p-0">
        {@html htmlContent}
      </div>
      <div class="mb-6 mt-3 flex items-center justify-center text-lg font-semibold text-white mobile:text-xl">To close preview, click within the gray area.</div>
    {/if}
  </div>
{/if}
<div class="relative min-h-screen w-full overflow-y-auto overflow-x-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  {#if showLoading}
    <div class="flex">
      <Loader>
        <span class="flex">
          {@html loadingText}
        </span>
      </Loader>
    </div>
  {/if}

  <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
  <div tabindex="0" bind:this={component} class="outline-0 focus-visible:outline-none">
    <div class="px-6 pb-12 pt-6">
      <div class="mx-auto w-full max-w-[920px]">
        <div class="mx-auto w-full">
          <button class:pointer-events-none={showLoading} type="button" on:click={backToList} style="text-decoration: none;" class="mb-1 hidden w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500 sm:mb-0 md:block">
            <span>
              <i class="fa-solid fa-reply" />
              <span>&nbsp;Back&nbsp;</span>
            </span>
          </button>

          <div class="flex flex-col justify-between md:flex-row">
            <div class="mx-auto mt-3 flex flex-col items-center justify-center mobile:mt-0 md:ml-0 md:items-start lg:mx-0">
              <div class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Edit Document Template</div>
            </div>

            <div class="mt-3 flex items-center justify-center gap-3 md:mt-0">
              <div data-tooltip="Back to List" tooltip-position="top" class="block md:hidden">
                <button class:pointer-events-none={showLoading} on:click={backToList} type="button" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none focus-visible:bg-blue-600 focus-visible:text-white focus-visible:outline-none active:bg-blue-500 dark:bg-lightgray dark:text-white dark:hover:bg-blue-500">
                  <i class="fa-solid fa-reply" />
                </button>
              </div>

              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <button
                type="button"
                tabindex="0"
                data-tooltip="Delete Template"
                tooltip-position="top"
                on:click={() => {
                  showDeleteModal = true
                }}
                class:pointer-events-none={showLoading}
                class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-red-600 hover:text-white focus:outline-none focus-visible:bg-red-600 focus-visible:text-white focus-visible:outline-none active:bg-red-500 dark:bg-lightgray dark:text-white dark:hover:bg-red-500"
              >
                <i class="fa-solid fa-trash-can" />
              </button>

              <button
                on:click={async () => {
                  await save()
                  showBackmodal = false
                }}
                class:pointer-events-none={showLoading}
                type="button"
                class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 sm:w-auto"
              >
                <span>
                  <i class="fa-solid fa-floppy-disk" />
                </span>
                <span class="select-none">&nbsp;Save&nbsp;Template</span>
              </button>
            </div>
          </div>
        </div>

        <div class="mx-auto mt-3 h-full w-full rounded-md bg-white p-6 dark:bg-darkgray">
          <div class="relative w-full rounded-md bg-white dark:bg-darkgray">
            <div class="space-y-3">
              <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                <div class="mb-1 block select-none text-base font-medium text-gray-200 sm:mb-0">Name</div>
                <div class="sm:col-span-2 sm:mt-0">
                  <input
                    required
                    on:blur={trimSpacesTemplateName}
                    on:blur={checkSpecialChars}
                    on:keypress={async (e) => {
                      clearTimeout(timer)
                      timer = setTimeout(await checkSpecialChars(e), 50)
                    }}
                    on:keypress={checkMaxCharacters}
                    on:paste={checkSpecialChars}
                    on:paste={checkMaxCharacters}
                    bind:this={input}
                    bind:value={template.name}
                    type="text"
                    class=" w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-slate-200 sm:text-sm"
                    placeholder="Document Template name "
                  />
                </div>
              </div>

              <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                <div class="mb-1 block select-none text-base font-medium text-gray-200 sm:mb-0">File Design Template</div>
                <div class="flex w-full gap-3 sm:col-span-2 sm:mt-0">
                  {#if loadDropdown}
                    <div class="flex h-[38px] w-full items-center rounded-md border border-[#a0a1a580] pl-5 text-sm text-white">
                      Loading&nbsp;&nbsp;
                      <span>
                        <Loading />
                      </span>
                    </div>
                  {:else}
                    <DropDown on:moveLast={fetchFileFinalList} on:moveFirst={fetchFileInitialList} bind:showLoading={showLoadingForDropDown} selectedName={fileTempName} on:itemSelect={onFileTempChange} on:selectedName={changeFileName} {startCount} {endCount} on:fetchNext={fetchFileNextTemplates} on:fetchPrevious={fetchFilePreviousTemplates} {maxPage} page={filepage} {count} selected={template.file || "None"} dropdownItems={$TemplatesList.file} type="File" />
                  {/if}
                  {#if template.file && fileTempName != undefined && fileTempName != "Choose a File Design Template"}
                    <button disabled={previewLoading || loadDropdown} on:click={filePreview} data-tooltip="Preview" tooltip-position="top" type="button" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none focus-visible:bg-blue-600 focus-visible:text-white focus-visible:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:text-gray-200 dark:bg-lightgray dark:text-white dark:hover:bg-blue-500">
                      <i class="fa-solid fa-eye" />
                    </button>
                  {/if}
                  <!-- <button data-tooltip="Edit" tooltip-position="top" type="button" class="flex h-9 w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed">
                      <i class="fa-solid fa-pen-to-square" />
                    </button> -->
                </div>
              </div>

              <div class="sm:grid sm:grid-cols-3 sm:items-start md:items-center">
                <div class="mb-1 block select-none text-base font-medium text-gray-200 sm:mb-0">Email Template</div>
                <div class="flex w-full gap-3 sm:col-span-2 sm:mt-0">
                  {#if loadDropdown}
                    <div class="flex h-[38px] w-full items-center rounded-md border border-[#a0a1a580] pl-5 text-sm text-white">
                      Loading&nbsp;&nbsp; <span>
                        <Loading />
                      </span>
                    </div>
                  {:else}
                    <DropDown type="Email" count={emailCount} startCount={emailStartCount} endCount={emailEndCount} maxPage={emailmaxPage} page={emailpage} on:moveLast={fetchEmailFinalList} on:moveFirst={fetchEmailInitialList} bind:showLoading={showLoadingForDropDown} selectedName={emailTempName} on:itemSelect={onEmailTempChange} on:selectedName={changeEmailName} on:fetchNext={fetchEmailNextTemplates} on:fetchPrevious={fetchEmailPreviousTemplates} selected={template.email || "None"} dropdownItems={$TemplatesList.email} />
                  {/if}

                  {#if template.email && emailTempName != undefined && emailTempName != "Choose a Email Template"}
                    <button disabled={previewLoading || loadDropdown} on:click={emailPreview} data-tooltip="Preview" tooltip-position="top" type="button" class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-blue-600 hover:text-white focus:outline-none focus-visible:bg-blue-600 focus-visible:text-white focus-visible:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:text-gray-200 dark:bg-lightgray dark:text-white dark:hover:bg-blue-500"><i class="fa-solid fa-eye" /></button>
                  {/if}
                  <!-- <button data-tooltip="Edit" tooltip-position="top" type="button" class="flex h-9 w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed">
                      <i class="fa-solid fa-pen-to-square" />
                    </button> -->
                </div>
              </div>
              <div class="w-full">
                <Tabs {items} />
              </div>
              <div class="flex w-full justify-end">
                <button
                  on:click={async () => {
                    await save()
                    showBackmodal = false
                  }}
                  class:pointer-events-none={showLoading}
                  type="button"
                  class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 sm:w-auto"
                >
                  <span>
                    <i class="fa-solid fa-floppy-disk" />
                  </span>
                  <span class="select-none">&nbsp;Save&nbsp;Template</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer />
</div>
